export enum Province {
  Alberta = 'Alberta',
  Manitoba = 'Manitoba',
  Saskatchewan = 'Saskatchewan'
}
